import { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	createStyles,
	makeStyles,
	type Theme,
	Grid,
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import CronScheduler from "@/components/cron-scheduler/src/Scheduler";
import { RecoilRoot } from "recoil";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		dialogContent: {
			width: "100%",
			padding: theme.spacing(4),
		},
		scheduler: {
			"& .MuiAutocomplete-root": {
				width: "100%",
				marginBottom: theme.spacing(3),
			},
			"& .MuiFormControl-root": {
				width: "100%",
				marginTop: theme.spacing(2),
				marginBottom: theme.spacing(2),
			},
			"& .MuiInputLabel-root": {
				fontSize: "1rem",
				marginBottom: theme.spacing(1),
			},
		},
		error: {
			color: theme.palette.error.main,
			fontSize: "0.875rem",
			marginTop: theme.spacing(1),
		},
	}),
);

type Props = {
	show: boolean;
	onClose: () => void;
	value: string | null;
	onChange: (value: string) => void;
};

export const CronExpressionModal = ({
	show,
	onClose,
	value,
	onChange,
}: Props) => {
	const classes = useStyles();
	const initialCronValue = value || "0 0 * * *";
	const [currentCronExp, setCurrentCronExp] = useState(initialCronValue);
	const [cronError, setCronError] = useState("");
	const { handleSubmit } = useForm();

	const onSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		e.stopPropagation();

		if (!cronError) {
			onChange(currentCronExp);
			onClose();
		}
	};

	const handleClose = () => {
		setCurrentCronExp(initialCronValue);
		onClose();
	};

	return (
		<Dialog open={show} onClose={handleClose} maxWidth="sm" fullWidth>
			<DialogTitle
				style={{
					padding: "20px 28px 10px",
				}}
			>
				<h1 style={{ fontSize: "1.3em" }}>Configure Schedule</h1>
			</DialogTitle>
			<form onSubmit={onSubmit} onClick={(e) => e.stopPropagation()}>
				<DialogContent className={classes.dialogContent} dividers>
					<div className={classes.scheduler}>
						<RecoilRoot>
							<CronScheduler
								cron={currentCronExp}
								setCron={setCurrentCronExp}
								setCronError={setCronError}
								isAdmin={false}
							/>
						</RecoilRoot>
					</div>

					{cronError && <div className={classes.error}>{cronError}</div>}
				</DialogContent>
				<Grid
					item
					md={12}
					xs={12}
					justifyContent="flex-end"
					style={{ margin: "15px 0" }}
				>
					<DialogActions style={{ padding: "0px 30px" }}>
						<Grid item md={3} xs={6} style={{ marginRight: "20px" }}>
							<Button
								fullWidth
								variant="contained"
								color="default"
								onClick={handleClose}
							>
								Cancel
							</Button>
						</Grid>
						<Grid
							item
							md={3}
							xs={6}
							style={{ margin: 0, padding: "8px 0 8px 0px" }}
						>
							<Button
								type="submit"
								color="primary"
								variant="contained"
								disabled={!!cronError}
								fullWidth
							>
								Save
							</Button>
						</Grid>
					</DialogActions>
				</Grid>
			</form>
		</Dialog>
	);
};
